import { createApp } from 'vue'
import App from './App.vue'
import 'aos/dist/aos.css'
import './index.css'
import router from './router'
import  'vue-animejs';
import { createI18n } from 'vue-i18n'


const messages = {
  en: require('./languages/english.json'),
  fr: require('./languages/french.json')
};

const i18n = createI18n({
locale: 'en', // set default locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
  legacy: false // <--- THIS IS THE IMPORTANT PART!
});

createApp(App).use(router).use(i18n).mount('#app');
